import {$getSelection, $isRangeSelection, $isTextNode} from 'lexical';

export const selectEndOfSelection = () => {
    const newSelection = $getSelection();
    if ($isRangeSelection(newSelection)) {
        const focusNode = newSelection.focus.getNode();
        const insertedEnd = newSelection.focus.offset;
        if ($isTextNode(focusNode)) {
            focusNode.select(insertedEnd, insertedEnd);
        }
    }
};
